import DeviceReservationsPage from "./DeviceReservationsPage";

export default DeviceReservationsPage;
